import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiAffiliateRejectedMaterialsList, apiAffiliateRejectedMaterialsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/affiliateRejectedMaterials/getData', async datas => {
    const { data } = await apiAffiliateRejectedMaterialsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/affiliateRejectedMaterials/getView', async id => {
    if (!id) return viewData
    const { data } = await apiAffiliateRejectedMaterialsView(id)
    data.images = []
    data.image_remove = []
    return data
})

const viewData = {
    affiliate_id: '',
    material_rejected: '',
    batch_reject_type_id: '',
    reject_type: '',
    date: '',
    notes: '',
    images: [],
    image_remove: [],
}

export const affiliateRejectedMaterialsSlice = createSlice({
    name: 'admin/affiliateRejectedMaterials',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = affiliateRejectedMaterialsSlice.actions

export default affiliateRejectedMaterialsSlice.reducer
